/** Display helpers for the AI workspace — integers and Persian digits only, no money maths. */

/** Integer with Persian digits and «٬» grouping (token counts, chart values). */
export function faInt(value: number): string {
  return Math.round(value).toLocaleString('fa-IR');
}

/** Chart values can be fractions or scaled amounts; preserve the supplied value. */
export function faChartValue(value: number): string {
  return value.toLocaleString('fa-IR', { maximumSignificantDigits: 17 });
}

/**
 * Splits a display string into plain and numeric runs so the numeric runs can
 * be rendered in tabular digits (`sk-num`). Matches Persian digit groups with
 * their «٬» / «٫» separators and an optional trailing «٪».
 */
export function splitDigitRuns(text: string): readonly { text: string; numeric: boolean }[] {
  return text
    .split(/([۰-۹]+(?:[٬٫][۰-۹]+)*٪?)/)
    .filter((part) => part !== '')
    .map((part) => ({ text: part, numeric: /^[۰-۹]/.test(part) }));
}
